import { CheckCircle2, RefreshCw, ShieldAlert, XCircle } from 'lucide-react'

// DNSBLs we monitor for IP reputation.
const MONITORED_DNSBLS = [
  { name: 'Spamhaus ZEN', key: 'spamhaus' },
  { name: 'Barracuda RBL', key: 'barracuda' },
  { name: 'SpamCop', key: 'spamcop' },
  { name: 'SORBS', key: 'sorbs' },
  { name: 'PSBL', key: 'psbl' },
] as const

// TODO: Wire to real DNSBL check API once available.
// For now, shows a static "clean" status as a placeholder.
// The actual DNSBL monitoring runs via the hourly cron (dnsbl-monitor.ts).

export function DnsblPanel(): React.JSX.Element {
  return (
    <div className="rounded-xl border border-surface-3 bg-surface-0">
      <div className="flex items-center justify-between border-b border-surface-3 px-5 py-4">
        <div className="flex items-center gap-2">
          <ShieldAlert className="h-5 w-5 text-text-secondary" />
          <h2 className="text-lg font-medium text-text-primary">DNSBL Status</h2>
        </div>
        <button
          type="button"
          className="inline-flex items-center gap-1.5 rounded-lg border border-surface-3 px-3 py-1.5 text-sm font-medium text-text-secondary transition-colors hover:bg-surface-1"
          title="Refresh DNSBL status"
        >
          <RefreshCw className="h-4 w-4" />
          Refresh
        </button>
      </div>

      <div className="divide-y divide-surface-2">
        {MONITORED_DNSBLS.map((dnsbl) => (
          <div key={dnsbl.key} className="flex items-center justify-between px-5 py-3">
            <span className="text-sm font-medium text-text-primary">{dnsbl.name}</span>
            <div className="flex items-center gap-2">
              <CheckCircle2 className="h-4 w-4 text-success" />
              <span className="text-sm text-success">Clean</span>
            </div>
          </div>
        ))}
      </div>

      <div className="border-t border-surface-2 px-5 py-3">
        <p className="text-xs text-text-tertiary">
          Auto-checked every hour. Last checked: just now
        </p>
      </div>
    </div>
  )
}

// Placeholder for when a DNSBL shows a listing (not currently wired).
export function DnsblListedRow({ name }: { name: string }): React.JSX.Element {
  return (
    <div className="flex items-center justify-between px-5 py-3 bg-red-50/50">
      <span className="text-sm font-medium text-text-primary">{name}</span>
      <div className="flex items-center gap-2">
        <XCircle className="h-4 w-4 text-danger" />
        <span className="text-sm font-medium text-danger">Listed</span>
      </div>
    </div>
  )
}
